<template>
  <div class="vote">
    <NavBar />
    <iframe src="https://unadulterated-fort.000webhostapp.com/vote/" frameBorder="0" scrolling="no" class="vote"></iframe>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "../components/Navbar/Navbar.vue";
import Footer from "../components/Footer/Footer.vue";

export default {
  components: {
    NavBar,
    Footer,
  },
};
</script>


<style scoped>
.vote {
  width: 100%;
  height: 100vh;
}
</style>